export default __webpack_public_path__ + "static/media/R70.f5a1f26b.png";